import { useTranslation } from "react-i18next";
import { ModalProps } from "antd";
import { Modal } from "..";

export function ConfirmModal({
  modalProps,
  translationNamespace,
  translationKey,
}: {
  modalProps?: ModalProps;
  translationNamespace: string;
  translationKey: string;
}) {
  const { t } = useTranslation(translationNamespace);
  return <Modal {...modalProps}>{t(translationKey)}</Modal>;
}
